






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditSeo.vue'
import ReadBaseSeo from '@/components/shared/ReadBaseSeo.vue'
import { AloPiscine, getDefaultAloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'ReadSeo',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadBaseSeo}
})
export default class ReadSeo extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean
 

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
